import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Params } from "@angular/router";
import { APIUrl } from "src/app/features-common/constants/APIUrls";
import { BaseService } from "src/app/framework/services/base.service";
import { Observable } from "rxjs";

@Injectable()
export class ProfileService extends BaseService {
  constructor() {
    super();
  }

  getprofiledata(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.userprofile}/${id}`);
  }
  updateProfile(formData): Observable<any> {
    return this.httpService.post(APIUrl.userprofile, formData);
  }
  getVerifyOtp(userId: any, notification: any): Observable<any> {
    let url = APIUrl.getUpdatePasswordOtp;
    let params = new HttpParams()
      .set("notification", notification)
      .set("userId", userId);
    return this.httpService.getParams(url, params);
  }

  verify(otp, userId): Observable<any> {
    let url = APIUrl.submitUpdatePswdOtp;
    let params = new HttpParams().set("otpNumber", otp).set("userId", userId);
    return this.httpService.postParams(url, params);
  }

  resetPassword(httpParams) {
    let url = APIUrl.resetProfilePassword;
    return this.httpService.put(url, httpParams);
  }

  // Get Logs

  getLogs(): Observable<any> {
    let url = APIUrl.logs;
    return this.httpService.get(url);
  }
}
